const APIEndPoint = 'https://api.dev.crmcondor.com';

export const environment = {
  production: true,
  APIEndPoint,
  appName: 'Dev - CRM Condor',
  headerColor: '#1e2d52',
};
